import * as React from 'react';
import { ReCAPTCHA } from '@brokerbay/design-components';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import styles from './appointment_book.module.scss';
import { OverrideOptionType } from './AppointmentOverride';

interface MobileButtonsProps {
  isMls: any;
  showCaptcha: any;
  currentStep: any;
  mobileWorkflowSteps: any;
  extAuth: any;
  clearSelected: any;
  listing: any;
  appointment: any;
  moveToNextStep: any;
  moveToPreviousStep: any;
  customContactSaved: any;
  dateNotAvailable: any;
  isAdmin: boolean;
  isListingContact: boolean;
  isTimeChange: boolean;
  isListingAgent: boolean;
  invalidTimeslot: any;
  showLoadingSpinnerInButton: any;
  verifyHuman: any;
  submitAppointment: any;
  updateState: any;
  isBookingVirtualTour: boolean;
  selectedTour: any;
  invitees: any[];
  isSubmitting: boolean;
  setIsSubmitting: React.Dispatch<React.SetStateAction<boolean>>;
  setHasMobileNumber: React.Dispatch<React.SetStateAction<boolean>>;
  addPropertyToTour: (
    listingId: string,
    virtualTourId: string,
    invitees: any[],
    captchaResponse?: string,
    captchaV3Token?: string,
  ) => void;
  showingOverrideType: OverrideOptionType;
}

const MobileButtons: React.FC<MobileButtonsProps> = ({
  isMls,
  showCaptcha,
  currentStep,
  mobileWorkflowSteps,
  extAuth,
  listing,
  appointment,
  customContactSaved,
  dateNotAvailable,
  isAdmin,
  isListingAgent,
  isListingContact,
  isTimeChange,
  invalidTimeslot,
  showLoadingSpinnerInButton,
  isBookingVirtualTour,
  selectedTour,
  invitees,
  isSubmitting,
  showingOverrideType,
  // functions
  setIsSubmitting,
  setHasMobileNumber,
  addPropertyToTour,
  updateState,
  verifyHuman,
  submitAppointment,
  clearSelected,
  moveToNextStep,
  moveToPreviousStep,
}) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  React.useEffect(() => {
    if (appointment.captchaResponse) {
      submitAppointment(false, appointment.captchaResponse);
    }
  }, [appointment.captchaResponse]);

  return (
    <div style={{ zIndex: 1000 }} className="row" id="mobile-buttons">
      <div className={`col-xs-12 visible-xs-block ${styles.buttonsContainer}`}>
        {/* Regular in person booking */}
        {!isBookingVirtualTour && (
          <>
            {isMls &&
              showCaptcha &&
              currentStep === mobileWorkflowSteps.confirmDetailsStep && (
                <ReCAPTCHA
                  data-cy="recaptcha-challenge"
                  onChange={response => {
                    updateState((draft: any) => {
                      draft.appointment.captchaResponse = response;
                    });
                  }}
                />
              )}

            {!(
              isMls &&
              showCaptcha &&
              currentStep === mobileWorkflowSteps.confirmDetailsStep
            ) && (
              <div>
                <span
                  className="pull-left"
                  style={{ position: 'relative', zIndex: 100 }}
                >
                  {extAuth &&
                    (extAuth.coopDashboard || extAuth.externalDashboard) && (
                      <a
                        onClick={clearSelected}
                        href={`/external/#/dash/${extAuth.dashboardId}/appointments/${appointment.id}`}
                        className="btn btn-danger btn-outline"
                      >
                        Cancel
                      </a>
                    )}

                  {!isMls && !extAuth && (
                    <a
                      className="btn btn-danger btn-outline"
                      href={`#/listing/${listing?.id}/view`}
                    >
                      Cancel
                    </a>
                  )}

                  {extAuth && extAuth.retsDashboard && (
                    <a className="btn invisible">Cancel</a>
                  )}
                </span>

                <span
                  style={{
                    display: 'flex',
                    position: 'absolute',
                    justifyContent: 'center',
                    marginLeft: '-15px',
                  }}
                  className="col-xs-12"
                >
                  <span style={{ marginLeft: '20px' }}></span>
                  {!(
                    (extAuth &&
                      currentStep > mobileWorkflowSteps.selectDateStep) ||
                    (!extAuth &&
                      currentStep > mobileWorkflowSteps.initialStep) ||
                    showingOverrideType
                  ) && (
                    <button className="btn btn-default btn-disabled invisible">
                      <i className="fa fa-chevron-left"></i> Back
                    </button>
                  )}

                  {((extAuth &&
                    currentStep > mobileWorkflowSteps.selectDateStep) ||
                    (!extAuth &&
                      currentStep > mobileWorkflowSteps.initialStep) ||
                    showingOverrideType) && (
                    <button
                      className="btn btn-default"
                      onClick={moveToPreviousStep}
                    >
                      <i className="fa fa-chevron-left"></i> Back
                    </button>
                  )}

                  {(appointment.coop || customContactSaved) &&
                    currentStep < mobileWorkflowSteps.confirmDetailsStep && (
                      <button
                        className="btn btn-info m-l-xs"
                        onClick={moveToNextStep}
                        disabled={
                          (currentStep === mobileWorkflowSteps.selectDateStep &&
                            dateNotAvailable) ||
                          (currentStep === mobileWorkflowSteps.selectTimeStep &&
                            !appointment.time)
                        }
                      >
                        Next <i className="fa fa-chevron-right"></i>
                      </button>
                    )}
                  {currentStep === mobileWorkflowSteps.confirmDetailsStep && (
                    <button
                      className="btn btn-info m-l-xs"
                      disabled={
                        !(
                          !appointment.recordAppointment &&
                          appointment.date &&
                          appointment.time &&
                          (isAdmin || isListingAgent || !invalidTimeslot)
                        ) && isSubmitting
                      }
                      onClick={async () => {
                        if (
                          isMls &&
                          !appointment.coop.phone &&
                          !extAuth?.hasFeature('SHOWING_AGENT_SMS')
                        ) {
                          setHasMobileNumber(false);
                          return;
                        }
                        setIsSubmitting(true);
                        if (isMls) {
                          if (executeRecaptcha && !showCaptcha) {
                            const token = await executeRecaptcha(
                              'bookAppointment',
                            );
                            submitAppointment(false, null, token);
                          } else {
                            verifyHuman();
                          }
                        } else {
                          submitAppointment();
                        }
                      }}
                      style={{ position: 'relative' }}
                    >
                      {isListingContact && isTimeChange
                        ? 'Send Suggestion'
                        : 'Book it!'}
                      <div
                        className={`btn btn-info ${
                          styles.loadingSpinnerInButton
                        } ${
                          showLoadingSpinnerInButton ? 'visible' : 'invisible'
                        }`}
                      >
                        <i className="fa fa-spinner fa-spin"></i>
                      </div>
                    </button>
                  )}
                </span>
              </div>
            )}
          </>
        )}

        {/* Virtual Tour mobile booking buttons */}
        {isBookingVirtualTour && (
          <>
            {showCaptcha && currentStep === 2 && (
              <ReCAPTCHA
                data-cy="recaptcha-challenge"
                onChange={response => {
                  addPropertyToTour(
                    listing.id,
                    selectedTour.id,
                    invitees,
                    response,
                  );
                }}
              />
            )}

            {!(currentStep > 1) && (
              <button className="btn btn-default btn-disabled invisible">
                <i className="fa fa-chevron-left"></i> Back
              </button>
            )}
            {!showCaptcha && currentStep > 1 && (
              <button className="btn btn-default" onClick={moveToPreviousStep}>
                <i className="fa fa-chevron-left"></i> Back
              </button>
            )}
            {currentStep === 1 && (
              <button
                className="btn btn-info m-l-xs"
                onClick={moveToNextStep}
                disabled={
                  (currentStep === 1 && !selectedTour) ||
                  (currentStep === mobileWorkflowSteps.selectTimeStep &&
                    !appointment.time)
                }
              >
                Next <i className="fa fa-chevron-right"></i>
              </button>
            )}
            {extAuth && !showCaptcha && currentStep === 2 && (
              <button
                className="btn btn-info m-l-xs"
                onClick={async () => {
                  if (executeRecaptcha) {
                    const token = await executeRecaptcha('bookVirtualTour');
                    addPropertyToTour(
                      listing.id,
                      selectedTour.id,
                      invitees,
                      null,
                      token,
                    );
                  } else {
                    updateState((draft: any) => {
                      draft.showCaptcha = true;
                    });
                  }
                }}
              >
                Add property to tour
              </button>
            )}
            {!extAuth && currentStep === 2 && (
              <button
                className="btn btn-info m-l-xs"
                onClick={() => {
                  addPropertyToTour(listing.id, selectedTour.id, invitees);
                }}
              >
                Add property to tour
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MobileButtons;
